import { css } from 'styled-components';
import { newColors } from '~/themes/variables';
import { mediaq } from '~/themes/style-utils-v2';
const styles = css `
  background-color: ${newColors.gray800};
  color: ${newColors.gray300};
  position: relative;
  padding: 10px 48px;
  display: flex;
  flex-direction: row;
  font-size: 12px;
  align-items: center;
  justify-content: space-between;
  height: 156px;
  ${mediaq.sm `
    flex-direction: column;
    padding: 34px 48px 24px;
    height: auto;
  `}
  .column {
    flex: 1;
  }
  .column + .column {
  }
  .links {
    text-align: right;
    ${mediaq.sm `
      display: flex;
      flex-direction: row;
      gap: 24px;
      padding-top: 24px;
    `}
  }
  .copyright {
    text-align: left;
    img {
      margin-top: 6px;
    }
    ${mediaq.sm `
      border-bottom: 1px solid ${newColors.gray500};
      padding-bottom: 36px;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
    `}
  }
  a {
    color: ${newColors.gray100};
    font-size: 14px;
    text-decoration: none;
    padding: 0 24px;
    ${mediaq.sm `
      padding: 0;
      font-size: 12px;
    `}
    &:last-child {
      padding-right: 0px;
      border-right: none;
    }
    &.brand.link {
      display: block;
      ${mediaq.sm `
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;`}
    }
  }
`;
export default styles;
